import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';

import { commonMessages } from './common';

export const archivesMessages = defineMessages({
  dragdropImage: {
    defaultMessage: 'Drag and drop your picture here or Click to browse.',
    id: 'dragdropImage',
  },
  clickToBrowse: {
    defaultMessage: 'Click to browse.',
    id: 'clickToBrowse',
  },
  dragdropImagePrompt: {
    defaultMessage:
      'Please upload 2 pictures of your watch (Face and Caseback)',
    id: 'dragdropImagePrompt',
  },
  extractFormTheArchives: {
    defaultMessage: 'extract from the archives',
    id: 'extractFormTheArchives',
  },
});

export const Dragdrop = () => {
  return (
    <FormattedMessage
      defaultMessage='Drag and drop your picture here or {action}'
      id='dragdropImage'
      values={{
        action: (
          <LinkWithLocale href='' target='_blank'>
            <FormattedMessage {...archivesMessages.clickToBrowse} />
          </LinkWithLocale>
        ),
      }}
    />
  );
};

export const ArchivesPrivacyPolicy = () => {
  return (
    <FormattedMessage
      defaultMessage='I have read and I accept the {termsOfUse} and the {privacyPolicy}'
      id='archivesPrivacyPolicy'
      values={{
        termsOfUse: (
          <LinkWithLocale href={paths.termsOfUse.url()} target='_blank'>
            <FormattedMessage {...commonMessages.termsOfUse} />
          </LinkWithLocale>
        ),
        privacyPolicy: (
          <LinkWithLocale href={paths.privacyPolicy.url()} target='_blank'>
            <FormattedMessage {...commonMessages.privacyPolicy} />
          </LinkWithLocale>
        ),
      }}
    />
  );
};
